<template>
  <CustomDialog
    class="bg-white! dark:bg-surface-primary"
    :visible="visible"
    :modalClass="modalClass"
    :class="modalClass"
    :closable="closable"
    @update:visible="updateVisible"
  >
    <template #header>
      <div class="inline-flex items-center justify-center gap-2">
        <font-awesome-icon
          v-if="icon"
          :icon="icon"
          class="text-[24px] font-extrabold leading-6 text-center"
          :class="iconColor"
        />
        <span
          class="font-600 dark:text-text-primary-dark text-text-primary"
          :class="textStyle"
        >
          {{ header }}
        </span>
      </div>
    </template>

    <!-- Descripción -->
    <template #description>
      <div class="inline-flex mt-3! items-center justify-center">
        <div class="flex items-center">
          <div
            :class="{
              'w-8 h-8 rounded-full border-[3px]! border-integra flex  justify-center':
                isCircle,
            }"
          >
            <font-awesome-icon
              v-if="iconDescription"
              :icon="iconDescription"
              class="text-[29px] font-extrabold leading-6 text-center"
              :class="[
                iconDescriptionColor,
                isCircle ? 'mt-0.5 text-[21px]!' : '',
              ]"
            />
          </div>
          <span
            class="text-text-secondary font-400 text-[14px] leading-5 tracking-[-0.4px] dark:text-text-primary-dark text-center"
            :class="iconDescription ? 'ml-2' : ''"
            v-html="description"
          >
          </span>
        </div>
      </div>
    </template>

    <!-- Contenido dinámico -->
    <template #content>
      <div v-if="isRejected">
        <div class="card">
          <div
            class="flex flex-col gap-1 bg-white border border-dark-secondary rounded-md p-3 shadow-2xs dark:bg-surface-primary dark:border-dark-border dark:text-text-primary-dark"
          >
            <span
              class="text-[13px] font-500 text-text-primary dark:text-text-primary-dark"
              >Motivo del rechazo</span
            >
            <CustomInput
              :modelValue="data.rejectionReason"
              @update:modelValue="data.rejectionReason = $event"
              inputClass="text-[14px]!"
              placeholder="Ingrese el motivo de rechazo..."
              type="text"
            />
          </div>
        </div>
      </div>

      <div v-if="isCorrected">
        <CustomInfoOperationTable
          :visible="isCorrected"
          :data="data.operationDetails"
          :observationSupervisor="data.observationSupervisor"
          :isAnalist="true"
          :isLastColumnColor="true"
          :colorLastColumn="'text-flying-fish-blue!'"
          modalClass=" "
          :header="'Correcciones'"
        />
      </div>
    </template>

    <!-- Botones -->
    <template #footer>
      <div
        class="flex"
        :class="{
          'justify-end gap-2': buttonType?.length === 2,
          'justify-center':
            buttonType?.length === 1 && buttonType[0] === 'Cancelar',
          'justify-end': buttonType?.length === 1,
        }"
      >
        <CustomButton
          v-for="(button, index) in buttonType"
          :key="index"
          :label="button"
          :text="button === 'Cancelar'"
          :variant="button === 'Cancelar' ? 'primary_outlined' : 'primary'"
          :class="['font-700 leading-4 tracking-[-0.2px]']"
          @click="button === 'Cancelar' ? cancel() : handleSuccess()"
        />
      </div>
    </template>
  </CustomDialog>
</template>

<script setup lang="ts">
import { PropType } from "vue";

const CustomButton = defineAsyncComponent(
  () => import("../ui/CustomButton.vue"),
);
const CustomInput = defineAsyncComponent(() => import("../ui/CustomInput.vue"));
const CustomInfoOperationTable = defineAsyncComponent(
  () => import("./CustomInfoOperationTable.vue"),
);
const CustomDialog = defineAsyncComponent(() => import("./CustomDialog.vue"));

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  visible: Boolean,
  header: String,
  description: String,
  icon: String,
  iconColor: String,
  borderModal: String,
  modalClass: String,
  buttonType: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  closable: Boolean,
  isRejected: Boolean,
  isCircle: Boolean,
  isCorrected: Boolean,
  iconDescription: String,
  iconDescriptionColor: String,
  textStyle: String,
});

const emit = defineEmits(["update:visible", "sendOperation"]);
const updateVisible = (value: boolean) => {
  emit("update:visible", value);
};

const cancel = () => {
  props.data.rejectionReason = "";
  emit("update:visible", false);
};

const handleSuccess = () => {
  emit("sendOperation");
};
</script>

<style scoped>
.align-items-center {
  align-items: start;
}
</style>
